export interface LendoxProduct {
  code: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  auctionApplicable: boolean;
  offerModel: string;
}

export const LENDOX_PRODUCTS: Record<string, LendoxProduct> = {
  SDF: {
    code: 'SDF',
    name: 'Smart Distribution Finance',
    description: 'Supply chain financing through E-D partnerships with direct lender assignment',
    icon: 'fa-link',
    color: '#0F62FE',
    auctionApplicable: false,
    offerModel: 'Direct lender assignment'
  },
  IF: {
    code: 'IF',
    name: 'Invoice Factoring',
    description: 'Sell receivables at a discount for immediate cash flow',
    icon: 'fa-file-invoice-dollar',
    color: '#00968F',
    auctionApplicable: true,
    offerModel: 'Auction Engine'
  },
  WCL: {
    code: 'WCL',
    name: 'Working Capital Loan',
    description: 'Credit facility for operational business needs',
    icon: 'fa-hand-holding-usd',
    color: '#DEA900',
    auctionApplicable: true,
    offerModel: 'Auction Engine'
  }
};
